"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const generateTypescriptConfig = {
    documents: ["./**/*.graphql", "!./src/types/**/*"],
    plugins: [
        {
            add: {
                content: "/* eslint-disable */",
            },
        },
        "typescript",
        "typescript-operations",
        "typed-document-node",
        "fragment-matcher",
    ],
    config: {
        gqlImport: "graphql-tag",
        skipTypename: true,
        withResultType: true,
        withMutationOptionsType: true,
        nameSuffix: "Type",
        operationResultSuffix: "OperationResult",
        avoidOptionals: false,
        maybeValue: "T | null",
        pureMagicComment: true,
    },
};
exports.default = generateTypescriptConfig;
//# sourceMappingURL=generate-react-typescript-config.js.map